import React, { useCallback, useState } from 'react';
import BarChartWidgetSC from './bar-chart-widget.styled';
import BarSegmentChart from '../../../../../components/bar-segment-chart';
import VitalItemHeader from '../../vital-list/vital-item-header';
import { VitalItemSC } from '../../vital-list/vital-list.styled';
import VitalItemFooter from '../../vital-list/vital-item-footer';
import HistoryDrawer from '../../history-drawer';
import {
  HistoryDrawerData,
  IVitalListEmptyEntry,
  IVitalListEntry,
} from '../../../../../types/life-id';
import { BarSegmentChartProps } from '../../../../../components/bar-segment-chart/bar-segment-chart';

interface BarChartWidgetProps {
  vitalEntry: IVitalListEntry | IVitalListEmptyEntry;
}

const BarChartWidget: React.FC<BarChartWidgetProps> = ({ vitalEntry }) => {
  const [drawerData, setDrawerData] = useState<HistoryDrawerData>({ type: 'HR' });

  const onDetailOpen = useCallback(() => {
    if (vitalEntry.isEmpty) return;

    setDrawerData({
      // @ts-ignore
      type: vitalEntry.modalType,
      args: {
        vitalListEntry: vitalEntry as IVitalListEntry,
      },
    });
    setDrawer(true);
  }, [vitalEntry]);
  const [drawer, setDrawer] = useState(false);

  if (!vitalEntry.barChartWidgetProps) return null;

  return (
    <>
      <BarChartWidgetSC>
        <VitalItemSC>
          <VitalItemHeader
            icon={<img src={vitalEntry.iconSrc} alt="" width="24" height="24" />}
            title={vitalEntry.title}
          />
          <BarSegmentChart {...(vitalEntry.barChartWidgetProps as BarSegmentChartProps)} />
          <VitalItemFooter
            isEmpty={vitalEntry.isEmpty}
            onDetailOpen={onDetailOpen}
            skipBadgeTranslation={(vitalEntry as IVitalListEntry).skipBadgeTranslation}
            badgeType={(vitalEntry as IVitalListEntry).badgeType}
            badgeText={(vitalEntry as IVitalListEntry).badgeText}
          />
        </VitalItemSC>
      </BarChartWidgetSC>
      <HistoryDrawer visible={drawer} drawerData={drawerData} onClose={() => setDrawer(false)} />
    </>
  );
};

export default BarChartWidget;
